import AuthenticatedUserAPI from '@/api/authenticated-user.js'
import UserDetailsAPI from '@/api/userdetails.js'
import OrganizationAPI from '@/api/organization.js'

export default {
  state: {
    user: null,
    authToken: null,
    loggedIn: false
  },
  mutations: {
    setLoggedIn (state, status) {
      state.loggedIn = status
    },
    setUser (state, user) {
      state.user = user
    },
    setToken (state, token) {
      state.authToken = token
    }
  },
  actions: {
    async getAuthenticatedUser ({commit}) {
      // TODO maybe have the auth endpoint on the DB just return all this information
      // instead of individual calls. Not a big deal but maybe just easier.
      const {data} = await AuthenticatedUserAPI.get()
      const userDetailsResponse = await UserDetailsAPI.getById(data.user_details_id)
      const userDetails = userDetailsResponse.data
      const organizationResponse = await OrganizationAPI.getById(userDetails.organization_id)
      userDetails.organization = organizationResponse.data
      data.userDetails = userDetails
      commit('setUser', data)
    }
  }
}
